<template>
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width="24" 
        height="24" 
        viewBox="0 0 24 24"
        fill="none" 
        :class="svgClass"
        :stroke="strokeColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round" 
        class="lucide lucide-map-pin-plus-icon lucide-map-pin-plus"
    >
        <path d="M19.914 11.105A7.298 7.298 0 0 0 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32 32 0 0 0 .824-.738"/>
        <circle cx="12" cy="10" r="3"/>
        <path d="M16 18h6"/><path d="M19 15v6"/>
    </svg>
</template>



<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps(['iconClass', 'stroke'])

const svgClass = computed(()=>{
    return props.iconClass ? props.iconClass : 'h-3 w-3'
})

const strokeColor = computed(() => {
    return props.stroke ? props.stroke : 'black'
})

</script>